import { MentionNameStatus } from '@atlaskit/mention';
import { config } from '@atlaskit/smart-common';
import { graphqlQuery } from './graphqlUtils';
const buildUsersQuery = accountIds => ({
  query: `query usersQuery($accountIds: [ID!]!) {
    users(accountIds: $accountIds) {
      name
      accountId
    }
  }`,
  variables: {
    accountIds
  }
});
const makeRequest = async (url, accountIds) => {
  const query = buildUsersQuery(accountIds);
  return graphqlQuery(url, query);
};
export class DefaultMentionNameResolver {
  constructor(baseUrl) {
    this.baseUrl = baseUrl;
    this.cache = new Map();
  }
  async lookupName(id) {
    try {
      var _data$users;
      if (this.cache.has(id)) {
        return {
          id,
          name: this.cache.get(id),
          status: MentionNameStatus.OK
        };
      }
      const url = config.getGraphQLUrl(this.baseUrl);
      const data = await makeRequest(url, [id]);
      const userInfo = (_data$users = data.users) === null || _data$users === void 0 ? void 0 : _data$users.find(user => user.accountId === id);
      return userInfo ? {
        id,
        name: userInfo.name,
        status: MentionNameStatus.OK
      } : {
        id,
        status: MentionNameStatus.UNKNOWN
      };
    } catch (error) {
      // on network error, return original list with label 'Unknown'
      return {
        id,
        status: MentionNameStatus.UNKNOWN
      };
    }
  }
  cacheName(id, name) {
    this.cache.set(id, name);
  }
}